import { FullscreenModule } from './../fullscreen.module/fullscreen.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PanelControlsComponent } from './panel-controls/panel-controls.component';
import { PanelComponent } from './panel.component';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { CollapseModule } from 'ngx-bootstrap/collapse';

@NgModule({
  imports: [
    CommonModule,
    TooltipModule.forRoot(),
    CollapseModule.forRoot(),
    FullscreenModule
  ],
  declarations: [
    PanelComponent,
    PanelControlsComponent
  ],
  exports: [
    PanelComponent,
    PanelControlsComponent
  ]
})
export class PanelModule { }



// WEBPACK FOOTER //
// ./src/app/core.module/modules/panel.module/panel.module.ts